// extracted by mini-css-extract-plugin
export default {"sm_sidebar":"sidebar_sm_sidebar__KuhlO"};